<script setup lang="ts">
import * as yup from "yup"
import { useOperationStore } from "~/stores/operation.store"
import { cloneDeep } from "lodash-es"

const operationStore = useOperationStore()

const REMARK_MAX_LENGTH = 10000

const schema = yup.object().shape({
  remark: yup.string(),
  completionConfirmation: yup.boolean().test(
    "is-checked",
    "Der Abschluss der Rechtsbehelfe muss bestätigt werden",
    yupTestOnlyOnCreate((value) => value === true)
  ),
})

type Schema = yup.InferType<typeof schema>

const currentWorkStepData = computed<Schema>(
  () => (operationStore.currentWorkStep?.data ?? {}) as unknown as Schema
)

const state = reactive<Schema>(cloneDeep(currentWorkStepData.value))
</script>

<template>
  <IffOperationWorkStepFormV2 :state="state" :schema="schema">
    <IffReviewsSection
      v-if="operationStore.currentWorkStep"
      :work-step-id="operationStore.currentWorkStep?.id"
      additional-headline="Organisation Rechtsbehelfe"
    />
    <IffContentSection headline="Abschluss">
      <UFormGroup
        name="remark"
        label="Bemerkung"
        :help="`Noch ${
          REMARK_MAX_LENGTH - (state.remark?.length ?? 0)
        } Zeichen verfügbar`"
      >
        <UTextarea
          v-model="state.remark"
          :maxlength="REMARK_MAX_LENGTH"
          resize
        />
      </UFormGroup>
    </IffContentSection>
    <IffContentSection headline="Bestätigen" :is-last-child="true">
      <UFormGroup name="completionConfirmation" required>
        <UCheckbox
          label="Ich bestätige den Abschluss der anliegenden Rechtsbehelfe."
          v-model="state.completionConfirmation"
          required
          aria-required="true"
        />
      </UFormGroup>
    </IffContentSection>
  </IffOperationWorkStepFormV2>
</template>
